export function generateRequiredOnInitializationParamMessageError(param) {
  return `"${param}" is required on Recommended source initialization!`;
}
export function generateRequiredOptionParamMessageError(param, method) {
  return `"${param}" is required on ${method} method options!`;
}
export function validateSettings(settings) {
  if (!settings.siteMediaToken) {
    throw new Error(generateRequiredOnInitializationParamMessageError('siteMediaToken'));
  }
}